import * as React from "react";
import {IInsuraceProduct, IInsuranceSubProducts} from "StateInterface";
import "./styles.scss";
import {handleNavigation} from "insurance/routes";
import {notifyDownload} from "utils/android";

export const faq = [
    {
        question: "Is Hospitalisation of all kinds covered in the Insurance?",
        ans: "Hospitalisation due to personal accident only will be covered in the insurance. Any hospitalisation due to other any other reasons is not covered.",
    },
    {
        question: "Is my family covered in the insurance?",
        ans: "No, the insurance coverage is only for the person registered with MyShubhLife & not for family.",
    },
    {
        question: "How can the registered person get the same cover for the family as well?",
        ans: "The cover is not available for the family as yet & MyShubhLife will communicate once the covers are available for the family as well.",
    },
    {
        question: "How can the user extend the cover after the cover tenure is complete?",
        ans: "Currently the coverage is for 1 year & they can reach out to MyShubhLife at the end of the tenure for more details on the process.",
    },
    {
        question: "How can the customer claim for the insurance?",
        ans: "Customer can reach out to GoodHealth at 9611396113 to claim for the insurance.",
    },
    {
        question: "What are the documents required to file the claim?",
        ans: "<b>For accidental death:</b> Duly completed claim form (Copy attached), Scan copy of Death Certificate, Scan Copy of FIR, Police Panchanama, Post Mortem Report, Scan Copy of Death Summary or Medical records, if treated in hospital, Scan Copy of news paper cutting, if any, Scan Copy of last drawn salary." +
            "<br/>" +
            "<b>For Dismemberment/ Partial / Permanent Total Disability:</b> Duly completed claim form (Copy attached), Scan Copy treating Doctor confirming the Disability percentage and prognosis for (PTD,PPD,DM), Scan Copy of FIR, Scan Copy of Discharge Summary or Medical records if treated in hospital, Scan Copy of news paper cutting if any, Scan Copy of last drawn salary slips (30 days salary)." +
            "<br/>" +
            "<b>Accidental Medical Expenses:</b> Duly completed claim form (Copy attached), Original Bills and Original Receipts, Original of Medical records/discharge card if hospitalized, Copy of consultation if any, Copy of FIR, if any.",
    },
    {
        question: "Which Hospitalisation expenses can be covered?",
        ans: "Personal Accidental Hospitalisation greater than 24 hours including treatment of injury, 2nd or 3rd degree burns, hospital charges, treatment charges can be covered upto Rs.25000 only.",
    },
    {
        question: "How to change the Customer Name which has been registered wrong in the Insurance Policy?",
        ans: "Reach out to MyShubhLife & share the ID proofs with the correct name which has to be mentioned. Note: Mobile number can not be changed, as it works as the Unique Identifier.",
    },
    {
        question: "Will the claim payment be cashless or reimbursement?",
        ans: "Claim Payments will be on reimbursement method. Cashless claims admission is not available.",
    },
    {
        question: "Is there any restriction on the hospitals ?",
        ans: "No, user can be hospitalised in any legally registered Hospital.",
    },
    {
        question: " If customer has met with an accident not hospitalised, but got treated as an Outpatient, can the insurance be claimed?",
        ans: "No, claims can be made only for hospitalisation. Also no claims can be made for diagnostics or tests as well.",
    },
];

export const COVER_TYPES = {
    INDIVIDUAL: "INDIVIDUAL",
    FAMILY: "FAMILY"
}

interface IListOfProducts {
    subCategory?: string;
    heading: string;
    identifier?: string;
    coverage?: string;
    validity?: string;
    price: string;
    title?: string;
    description?: string;
    icon?: string;
    routeName?: string;
    show?: boolean;
    selectedIndex?: number;
    coverType?: string;
    handleClick: (routePath: string, productName: string, subCategory?: string) => void;
}
export function productCard(listOfProducts: IListOfProducts[]) {
    return (
        <div className={"text-left"}>
            {listOfProducts.map((product, index) => {
                if (!product.show) return null;
                return (
                    <div className={"product-card shadow"} key={index}
                         onClick={() => product.handleClick(product.routeName, product.identifier, product.subCategory)}>
                        <div className={"d-flex flex-row align-items-center"}>
                            <div className={"product-card-icon"}><img src={product.icon} /></div>
                            <div className={"pl-3"}>
                                <div className={"product-heading mb-1"}>{product.heading} </div>
                                <div style={{color: "gray"}}>Starting at: <b style={{color: "#d6791bfa"}}>
                                    {Number(product.price) > 0 ? <span><i className="fa fa-inr price" aria-hidden="true"/> {product.price}</span> : " Free"}</b>
                                </div>
                            </div>
                            <div className={"ml-auto p-2"}><i className="fa fa-angle-right"/></div>
                        </div>
                        </div>
                );
            })}
        </div>
    );
}
export function productListCard(listOfProducts: IListOfProducts[]) {
    return (
        <div className={"product-card-section"}>
            {listOfProducts.map((product, index) => {
                if (!product.show) return null;
                return (
                    <div className={`${product.selectedIndex ? "card-price-selected" : "card-price"} text-center p-1`} key={index}
                         onClick={() => product.handleClick(product.routeName, product.identifier)}>
                        <p className="p-1 m-0">
                            {product.heading.length > 18 ? `${product.heading.substr(0, 17)}..` : product.heading}
                        </p><hr/>
                        <p className="m-0 p-1 pt-2">
                            <b><i className="fa fa-inr price text-dark" aria-hidden="true"/>&nbsp;
                            {addCommas(product.coverage)}</b> (<b>1 Yr</b>)
                        </p>
                        <p className="pb-1 px-1 m-0 cover-type">{product.coverType}</p>
                        <p className={"price-value"}>
                            <b style={{color: "#d6791bfa"}}>{Number(product.price) > 0 ?
                               <span><i className="fa fa-inr price" aria-hidden="true"/>&nbsp;
                                 {addCommas(product.price)}</span> : " Free"}</b>
                        </p>
                    </div>
                );
            })}
        </div>
    );
}
export function getEventForProduct(productName: string) {
    return productName.toUpperCase().replace(/ /g, "_");
}
interface IFloatingNavButton {
    routeTo: string;
    label: string;
}
export function floatingNavButton(props: IFloatingNavButton) {
    return (
        <div className={"float-nav-btn"} onClick={() => handleNavigation(props.routeTo)}>
            <span>{props.label}</span>
        </div>
    );
}
export function sortAvailableProducts(products: IInsuraceProduct[]) {
    products.sort((a, b) => a.sumInsured - b.sumInsured);
    return products.map(product => ({...product, isIndividual: product.coverType.type === COVER_TYPES.INDIVIDUAL}));
}
export function getSubProducts(products: IInsuraceProduct[]) {
    const subProducts: IInsuranceSubProducts | object = {};
    products.forEach((obj) => {
        let  _productCoverTypes = []
        const coverType = obj.coverType.type === COVER_TYPES.INDIVIDUAL ? COVER_TYPES.INDIVIDUAL : COVER_TYPES.FAMILY;
        if (subProducts.hasOwnProperty(obj.subCategory)) {
            _productCoverTypes = [...subProducts[obj.subCategory]['productCoverTypes'], ...[coverType]];
            if (obj.productPrice < subProducts[obj.subCategory].productPrice) {
                subProducts[obj.subCategory] = {
                    productPrice: obj.productPrice,
                    title: obj.subCategoryCovers.description,
                    icon: obj.subCategoryCovers.displayImage,
                    productCoverTypes: Array.from(new Set(_productCoverTypes)),
                };
            } else {
                subProducts[obj.subCategory]['productCoverTypes'] = Array.from(new Set(_productCoverTypes));
            }
        } else {
            _productCoverTypes.push(coverType);
            subProducts[obj.subCategory] = {
                productPrice: obj.productPrice,
                title: obj.subCategoryCovers.description,
                icon: obj.subCategoryCovers.displayImage,
                productCoverTypes: Array.from(new Set(_productCoverTypes)),
            };
        }
    });
    return subProducts;
}
export function downloadPdfFromBase64(pdf: string, fileName: string) {
    const linkSource = `data:application/pdf;base64,${pdf}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = `${fileName}.pdf`;
    downloadLink.click();
}
export function downloadPDF(url: string, filename: string, isAndroid: boolean) {
    fetch(url).then((response) => {
        return response.blob().then((blob) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.addEventListener("load", () => {
                if (typeof reader.result === "string") {
                    const base64Data = reader.result.replace(/^data:.+;base64,/, "");
                    if (isAndroid) {
                        notifyDownload(filename, base64Data, null, "application/pdf");
                    } else {
                        downloadPdfFromBase64(base64Data, filename);
                    }
                }
            });
        });
    });
}

export function addCommas(amount: any) {
    if (amount >= 10000000) {
        amount = (amount / 10000000) + " Cr";
    } else if (amount >= 100000) {
        amount = (amount / 100000) + " Lakh";
    } else {
        amount = amount.toString();
        let lastThree = amount.substring(amount.length - 3);
        const otherNumbers = amount.substring(0, amount.length - 3);
        if (otherNumbers !== "")
            lastThree = "," + lastThree;
        amount = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    }
    return amount;
}

export const downloadPdfFromPreSignedUrl = (preSignedUrl: string, isAndroid: boolean) => {
        return fetch(preSignedUrl).then((resp) => {
            resp.text().then((bs64data) => {
                if (isAndroid) {
                    notifyDownload("insurance_policy", bs64data, null, "application/pdf");
                } else {
                    downloadPdfFromBase64(bs64data, "insurance_policy");
                }
            });
        });
    };